<template>
  <div class="chart-date-filter-row">
    <label class="chart-filter-label">
      Data Início:
      <input
        v-model="localStartDate"
        type="date"
        class="chart-filter-input"
      />
    </label>
    <label class="chart-filter-label">
      Data Fim:
      <input
        v-model="localEndDate"
        type="date"
        class="chart-filter-input"
      />
    </label>
    <button
      type="button"
      class="chart-search-btn"
      title="Buscar e actualizar gráfico (todos os silos)"
      :disabled="loading || !localStartDate || !localEndDate"
      @click="onSearch"
    >
      <i :class="loading ? 'fas fa-spinner fa-spin' : 'fas fa-search'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ChartDateFilter',
  props: {
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localStartDate: this.startDate || '',
      localEndDate: this.endDate || ''
    };
  },
  watch: {
    startDate(val) {
      if (val != null && val !== this.localStartDate) this.localStartDate = val;
    },
    endDate(val) {
      if (val != null && val !== this.localEndDate) this.localEndDate = val;
    }
  },
  methods: {
    onSearch() {
      if (!this.localStartDate || !this.localEndDate) return;
      this.$emit('search', this.localStartDate.trim().slice(0, 10), this.localEndDate.trim().slice(0, 10));
    }
  }
};
</script>

<style scoped>
.chart-filter-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.chart-filter-input {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  background-color: #fff;
  min-width: 140px;
}

.chart-filter-input:focus {
  outline: none;
  border-color: #1b4238;
}

.chart-search-btn {
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1b4238;
  border-radius: 6px;
  background-color: #1b4238;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s, opacity 0.2s;
}

.chart-search-btn:hover:not(:disabled) {
  background-color: #2d5a4a;
}

.chart-search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.chart-date-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
}
</style>
